import {
	RenderComponent,
	RenderSearchLink,
	RenderSearchField,
	RenderLanguageLink,
	RenderLanguageField,
	RenderHamburgerButton,
	RenderSearchPage,
	RenderListPageWithCategories
} from "Framework";

export default {
	init: (model, element, menu) => {
		RenderComponent(model, element, menu);
	},

	initSearch: (element, model, searchQuery) => {
		RenderSearchPage(element, model, searchQuery);
	},
	initListPageWithCategories: (element, model, searchQuery) => {
		RenderListPageWithCategories(element, model, searchQuery);
	},
};
